(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer-topbar"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimerBar extends HTMLElement {
      constructor() {
          super();
      }

      init() {
          this.schemaTime = this.getAttribute('schema-time');

          this.timer = this.querySelector(".timer")
          this.countdown = new Date(this.schemaTime).getTime();
          this.second = 1000;
          this.minute = this.second * 60;
          this.hour = this.minute * 60;
          this.day = this.hour * 24;

          this.timerInterval = null;
          this.startTimer();

          setTimeout(() => this.timer.style.visibility = "visible", 1000)
      }

      padWithLeadingZero = (number) => {
          if (number < 10) {
              return '0' + number;
          } else {
              return number;
          }
      };

      isDateInPast(date) {
          const now = new Date();
          return date < now;
      }


      startTimer() {
          //Have quick check to see if Date input in the countdown class variable is in the past
          //Helper function

          const timerElem = this.timer
          this.timerInterval = setInterval(() => {
              const now = new Date().getTime();
              const distance = this.countdown - now;

              const dayCalc = Math.floor(distance / this.day);
              const hourCalc = Math.floor((distance % this.day) / this.hour);
              const minuteCalc = Math.floor((distance % this.hour) / this.minute);
              const secondCalc = Math.floor((distance % this.minute) / this.second);

              timerElem.querySelector('.js-timer-days').textContent = this.padWithLeadingZero(dayCalc);
              timerElem.querySelector('.js-timer-hours').textContent = this.padWithLeadingZero(hourCalc);
              timerElem.querySelector('.js-timer-minutes').textContent = this.padWithLeadingZero(minuteCalc);
              timerElem.querySelector('.js-timer-seconds').textContent = this.padWithLeadingZero(secondCalc);
          }, this.second);
      }

      disconnectedCallback() {
          clearInterval(this.timerInterval);
      }

      connectedCallback(){
          this.init();
          console.log("countdown timer was added to the page")

          const timerFlexContainer = window.document.querySelector(".timer-flex-container")
          const timerElem = this.timer

          const pastDate = this.isDateInPast(this.countdown)
          if(pastDate){
              timerFlexContainer.remove()
              this.remove()
          }
          window.setTimeout(() => {
              timerFlexContainer.classList.remove("hide-element")
          }, 2000);
      }

      disconnectedCallback(){
          console.log("The Timer date has passed so the timer was removed")
      }
  }

  customElements.define('countdown-timer-bar', CountdownTimerBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
